import BlockImagesTextTemplate from './BlockImagesTextTemplate';
export default defineComponent({
  name: 'BlockImagesTextStandard',
  components: {
    BlockImagesTextTemplate: BlockImagesTextTemplate
  },
  props: {
    isPageAdvice: Boolean,
    title: {
      type: String
    },
    text: {
      type: String
    },
    classes: {
      type: Object,
      default: function _default() {}
    },
    pictos: {
      type: Array
    },
    backgroundWhite: Boolean,
    isOverlay: Boolean,
    bottomContent: Boolean,
    leafListOption: Boolean,
    isRecipePage: Boolean,
    isHomePage: Boolean
  }
});